import React from "react";
import LocationFleetCms from "./LocationFleetCms";

const YachtPartiesCms = () => (
  <LocationFleetCms
    pageKey="yacht-party-mumbai"
    heading="Yacht Parties"
    intro="Manage yachts for the Yacht Parties page. Tick Mumbai and/or Goa so the same yacht can appear in both locations."
  />
);

export default YachtPartiesCms;
